<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-09-20 09:19:57
 * @LastEditTime: 2019-09-20 13:28:25
 * @LastEditors: Please set LastEditors
 -->
<template>
    <div id="page_Container" class="networong-page">
        <div class="page">
            <div id="main-container" class="page-style main-container">
                <div class="tips">加载异常，请关闭页面重新进入～</div>
                <!-- <van-button plain round type="danger" style='margin-top:30px;' @click="backClick">立即刷新</van-button> -->
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'pageAnomaly',
    data() {
        return {
            imgPreLoadBox: []
        };
    },
    esvReady: function() {
        document.title = '鉴权异常';
    },
    methods: {
        backClick() {
            this.$router.go(-1);
        }
    }
};
</script>
<style  lang="scss" scoped>
.networong-page {
    width: 100%;
    background-color: #f3f3f3;
    display: flex;
    display: -webkit-flex;
    align-items: center;
    justify-content: center;
    .page-style {
        text-align: center;
    }
    img {
        margin: 138px auto 14px;
        width: 202px;
    }
    .tips {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #999;
        letter-spacing: 0;
    }
    .refresh {
        width: 120px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        margin: 12px auto;
        font-size: 14px;
        color: #ee2e50;
        cursor: pointer;
        border: 1px solid #ee2e50;
        border-radius: 20px;
    }
}
</style>
